import { createSelector, createIdSelector } from 'redux-views';

export const storeState = state => state.onboarding;
